import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HarvestComponent } from './harvest.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    HarvestComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ], exports: [
    HarvestComponent
  ]
})
export class HarvestModule { }
